import 'css-chunksrc/client/scenes/assignToTask/projectSelection/styles.scss';export default {
  "projectsSelection": "_projectsSelection_etx4x_1",
  "root": "_root_etx4x_12",
  "search": "_search_etx4x_18",
  "list": "_list_etx4x_22"
};